export default "__VITE_ASSET__CyM6FqgO__"